import { render } from "./WasUnsAusmacht.vue?vue&type=template&id=24d85847"
import script from "./WasUnsAusmacht.vue?vue&type=script&lang=ts"
export * from "./WasUnsAusmacht.vue?vue&type=script&lang=ts"

import "./WasUnsAusmacht.vue?vue&type=style&index=0&id=24d85847&lang=scss"
script.render = render

export default script